import React from 'react';
import { func_datetime, func_validation, isStringTrimNotEmpty } from 'functions';

export function useReportTableColumns() {
    
    function getColumn_comId() {
        let columnClassName = "columns__comId";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "COM ID",
            id: "comId",
            accessor: "ComId",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNotNullUndefined(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_comName() {
        let columnClassName = "columns__comName";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "COM Name",
            id: "comName",
            accessor: "ComName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isNotNullUndefined(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_licenseKey() {
        let columnClassName = "columns__licenseKey";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "License Key",
            id: "licenseKey",
            accessor: "LicenseKey",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_licenseSource() {
        let columnClassName = "columns__licenseSource";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "License Source",
            id: "licenseSource",
            accessor: "LicenseSource",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_isTrial() {
        let columnClassName = "columns__isTrial";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial Status",
            id: "isTrial",
            accessor: "IsTrial",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? "Yes":"No"

                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_creationDate() {
        let columnClassName = "columns__creationDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Creation Date",
            id: "creationDate",
            accessor: "CreationDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_deletedDate() {
        let columnClassName = "columns__deletedDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Deleted Date",
            id: "deletedDate",
            accessor: "DeletedDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_trialExpiredDate() {
        let columnClassName = "columns__trialExpiredDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial Expired Date",
            id: "trialExpiredDate",
            accessor: "TrialExpiredDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    return [
        getColumn_comId(),
        getColumn_comName(),
        getColumn_licenseKey(),
        getColumn_licenseSource(),
        getColumn_isTrial(),
        getColumn_creationDate(),
        getColumn_deletedDate(),
        getColumn_trialExpiredDate()
    ]
}